import { Pano } from "../Pano.js";

export enum ControlPosition {
    LEFT = "left",
    RIGHT = "right",
    TOP = "top",
    CONTAINER = "container"
    // CENTER = "center"
}

export class BaseControl {

    public onVisibilityChanged = e5.Signal.create<[boolean]>();
    public element: HTMLDivElement;
    public pano: Pano;
    public position: ControlPosition;

    protected _video: HTMLVideoElement;

    constructor(pano: Pano, position: ControlPosition = ControlPosition.LEFT) {
        this.pano = pano;
        this._video = pano.video;
        this.position = position;
        this.element = document.createElement("div");
        this.element.classList.add("base-control");
    }

    protected addIcon(ic: string, parent: HTMLElement = this.element): HTMLDivElement {
        var icon = document.createElement("div");
        icon.className = "control-button-icon " + ic;
        parent.appendChild(icon);
        return icon;
    }

    public get visible(): boolean {
        return !this.element.classList.contains("hidden");
    }

    public set visible(v: boolean) {
        this.element.classList.toggle("hidden", !v);
        this.onVisibilityChanged.dispatch(v);
    }
}